import { useEffect, useState } from "react";

export default function WTCrossExplain() {
  const [now, setNow] = useState(new Date());

  // ========================
  // Animación wave del título
  // ========================
  const waveText = (text) =>
    text.split("").map((char, idx) => (
      <span
        key={idx}
        className="wave inline-block"
        style={{ animationDelay: `${idx * 0.05}s` }}
      >
        {char}
      </span>
    ));

  useEffect(() => {
    const interval = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="min-h-screen bg-slate-900 text-slate-100 font-sans p-10 flex flex-col items-center">
      {/* TITULO PRINCIPAL */}
      <h1 className="text-5xl md:text-6xl font-extrabold uppercase text-emerald-400 drop-shadow-[0_2px_10px_rgba(16,185,129,0.8)] mb-12 text-center">
  {waveText("WT CROSS EXPLICADO")}
</h1>


      {/* EXPLICACION DEL WT CROSS */}
      <div className="max-w-4xl bg-slate-800/80 p-8 rounded-3xl shadow-2xl border border-slate-700 mb-10">
        <h2 className="text-2xl font-bold text-emerald-400 mb-4">
          ¿Qué es el WT CROSS de LazyBear?
        </h2>
        <p className="text-slate-300 text-base md:text-lg mb-4">
          El <strong>WT CROSS</strong> es un indicador creado por <em>LazyBear</em>
           que combina ondas estocásticas y suavizado para detectar posibles
          cambios de tendencia en el mercado. Su objetivo es señalar:
        </p>

        <ul className="list-disc list-inside text-slate-300 mb-4 space-y-2">
          <li>
            🟢 <strong>Compra / Expansión:</strong> Onda rápida cruza la onda lenta hacia arriba.
          </li>
          <li>
            🟡 <strong>Precaución / Sobreextensión:</strong> El cruce ocurre pero el mercado muestra divergencia.
          </li>
          <li>
            🔴 <strong>Venta / Distribución:</strong> Onda rápida cruza hacia abajo, indicando posible caída.
          </li>
        </ul>

        <p className="text-slate-300">
          El indicador utiliza colores y alertas visuales similares a un semáforo,
          facilitando identificar tendencias alcistas, zonas de sobrecompra y ventas.
        </p>
      </div>

      {/* EJEMPLO VISUAL */}
      <div className="max-w-5xl w-full grid grid-cols-1 md:grid-cols-3 gap-6 mb-12">
        <div className="rounded-2xl border border-emerald-500/40 bg-slate-800/70 p-6 flex flex-col items-center text-center">
          <span className="text-4xl mb-2">🟢</span>
          <h3 className="text-emerald-400 font-bold mb-2 text-lg">EXPANSIÓN</h3>
          <p className="text-slate-300 text-sm md:text-base">
            La onda rápida cruza hacia arriba la lenta. Momento ideal para abrir
            posiciones largas.
          </p>
        </div>
        <div className="rounded-2xl border border-yellow-500/40 bg-slate-800/70 p-6 flex flex-col items-center text-center">
          <span className="text-4xl mb-2">🟡</span>
          <h3 className="text-yellow-400 font-bold mb-2 text-lg">SOBREEXTENSIÓN</h3>
          <p className="text-slate-300 text-sm md:text-base">
            Cruce incierto o divergencia. Se recomienda precaución, esperar confirmación.
          </p>
        </div>
        <div className="rounded-2xl border border-red-500/40 bg-slate-800/70 p-6 flex flex-col items-center text-center">
          <span className="text-4xl mb-2">🔴</span>
          <h3 className="text-red-400 font-bold mb-2 text-lg">DISTRIBUCIÓN</h3>
          <p className="text-slate-300 text-sm md:text-base">
            La onda rápida cruza hacia abajo la lenta. Momento de cerrar o reducir posiciones.
          </p>
        </div>
      </div>

      {/* FOOTER CON HORA */}
      <div className="text-center text-slate-400 text-sm md:text-base mt-auto">
        Hora actual:{" "}
        {now.getHours().toString().padStart(2, "0")}:
        {now.getMinutes().toString().padStart(2, "0")}:
        {now.getSeconds().toString().padStart(2, "0")} (Local)
      </div>

      {/* ESTILO DE WAVE */}
      <style jsx>{`
        @keyframes wave {
          0%, 60%, 100% { transform: translateY(0); }
          30% { transform: translateY(-8px); }
        }
        .wave {
          display: inline-block;
          animation: wave 1s infinite;
        }
      `}</style>
    </div>
  );
}
